import AppTour from '@components/tour/AppTour';
import { TOUR_ID } from '@components/tour/tours';
import { useObjectPickerStore } from '@stores/useObjectPickerStore';

/**
 * `AppTour` as the detection wizard sees it.
 *
 * Each stage states the page it wants, never a change relative to the previous
 * step, because the tour runs backwards too. Stages only move between pages;
 * the user's selection, area and preview are left alone, and closing the tour
 * returns the wizard to its first page.
 *
 * `suppressed` comes from the wizard shell, whose `useRunDetection` owns the
 * in-flight state.
 */

const showPage = step => useObjectPickerStore.setState({ step });

const STAGES = {
	collection: () => showPage(0),
	area: () => showPage(1),
	run: () => showPage(2),
};

const ObjectPickerTour = ({ suppressed = false }) => (
	<AppTour
		tourId={TOUR_ID.AI_DETECTION}
		suppressed={suppressed}
		stages={STAGES}
		cleanup={STAGES.collection}
	/>
);

export default ObjectPickerTour;
